import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AttendanceSyncDetails from "./routes/AttendanceSyncDetails";

export default store => ({
  path: "dashboard",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AttendanceSyncDetails(store)],
});
